<template>
    <div>
        <v-text-field
            v-model="search"
            label="Cari"
            clearable
        ></v-text-field>

        <v-data-table
            :headers="headers"
            :items="flattenedQuestions"
            :search="search"
            dense
            :items-per-page="-1"
            :custom-sort="sort"
            item-key="index"
        >
            <template #item.selection="{ item }">
                <v-checkbox
                    v-model="selectedQuestions"
                    :value="item.id"
                    @change="
                        $emit('update:selectedQuestions', selectedQuestions)
                    "
                ></v-checkbox>
            </template>

            <template #item.similiarity="{ item }">
                <v-btn
                    @click="$emit('similiarityClick', item)"
                    v-if="item.similiarities.length != 0"
                    color="red"
                    dark
                    small
                >
                    {{ item.similiarities.length }}
                </v-btn>
            </template>

            <template #item.action="{ item }">
                <v-btn
                    @click="swap(item)"
                    icon
                >
                    <v-icon>mdi-swap-horizontal</v-icon>
                </v-btn>
                <v-btn
                    @click="remove(item)"
                    icon
                    color="red"
                >
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <swap-question
            @update:questions="questionSwapped"
            ref="swapQuestion"
        ></swap-question>
    </div>
</template>

<script>
import SwapQuestion from './SwapQuestion.vue'

export default {
    props: {
        questions: {
            type: Array,
        },
        similiarities: {
            type: Object,
        },
        tryouts: {
            type: Array,
        },
        tryoutIdx: {
            type: Number,
        },
    },

    components: {
        SwapQuestion,
    },

    data: () => ({
        search: null,
        recentActionedItem: null,
        selectedQuestions: [],
        headers: [
            { text: 'Pilih', value: 'selection' },
            { text: 'Bank soal', value: 'questionBank' },
            { text: 'Pertanyaan', value: 'question' },
            { text: 'Bidang', value: 'field' },
            { text: 'Kesamaan', value: 'similiarity', searchable: false },
            {
                text: 'Aksi',
                value: 'action',
                sortable: false,
                searchable: false,
            },
        ],
    }),

    computed: {
        isRecentActionedItemHasLocalSimiliarities() {
            return (
                this.recentActionedItem.similiarities.find(
                    (similiarity) => similiarity.localOccurence !== undefined
                ) !== undefined
            )
        },

        flattenedQuestions() {
            const result = []

            if (!this.questions) {
                return []
            }

            for (const index in this.questions) {
                const similiarities =
                    this.similiarities &&
                    this.similiarities[this.tryoutIdx] &&
                    this.similiarities[this.tryoutIdx][index]
                        ? this.similiarities[this.tryoutIdx][index]
                        : []
                const question = this.questions[index]
                result.push({
                    index: index,
                    id: question.id,
                    questionBank: question.questionBank.title,
                    question: question.question,
                    field: question.field.title,
                    similiarities,
                })
            }

            return result
        },
    },

    methods: {
        remove(item) {
            const questions = Array.from(this.questions)
            this.recentActionedItem = item

            questions.splice(
                questions.findIndex((question) => question.id == item.id),
                1
            )

            this.$emit('update:questions', questions)

            this.emitSimiliarityChangeIfNecessary()
        },

        swap(item) {
            this.recentActionedItem = item
            this.$refs.swapQuestion.show(this.questions, item)
        },

        questionSwapped(event) {
            this.$emit('update:questions', event)

            this.emitSimiliarityChangeIfNecessary()
        },

        emitSimiliarityChangeIfNecessary() {
            if (this.isRecentActionedItemHasLocalSimiliarities) {
                this.$nextTick(() => this.$emit('similiarityChange'))
            }
            this.recentActionedItem = null
        },

        sort(items, sortBy, sortDesc) {
            for (const index in sortBy) {
                const value = sortBy[index]

                if (['questionBank', 'question', 'field'].includes(value)) {
                    items.sort((a, b) => {
                        if (a[value] == b[value]) {
                            return 0
                        }

                        return a[value] < b[value] && !sortDesc[index] ? -1 : 1
                    })
                } else if (value == 'similiarity') {
                    items.sort((a, b) => {
                        const countA = a.similiarities
                        const countB = b.similiarities

                        if (countA == countB) {
                            return 0
                        }

                        return countA > countB && !sortDesc[index] ? -1 : 1
                    })
                }
            }

            return items
        },
    },
}
</script>
